module.exports = "/dist/montserrat-latin-300.svg?b45e2b2fa43b5b10dbe4f1490e45261b";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300.svg
// module id = 70
// module chunks = 0